module.exports = __webpack_public_path__ + "img/1.3db1e4df.svg";